import { render } from "./RegisterTest.vue?vue&type=template&id=7b2dbea1&scoped=true&ts=true"
import script from "./RegisterTest.vue?vue&type=script&lang=ts"
export * from "./RegisterTest.vue?vue&type=script&lang=ts"

import "./RegisterTest.vue?vue&type=style&index=0&id=7b2dbea1&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2dbea1"]])

export default __exports__